import React from 'react';
import { Flex } from 'rebass/styled-components';
import { trackStatsService } from '../services/services';

const Document = ({ docId, setDisableSend, next }) => {
  const url = 'https://app.pandadoc.com/s/' + docId;

  var eventMethod = window.addEventListener
      ? 'addEventListener'
      : 'attachEvent',
    messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';
  window[eventMethod](
    messageEvent,
    async function(e) {
      if (e && e.data) {
        try {
          var message = JSON.parse(e.data);
          if (message && message.event) {
            if (message.event == 'session_view.document.completed') {
              setDisableSend(false);
              message.event = '0';

              const data = {
                event: 'SIGNED_CONSENT'
              };
              try{
                let response = await trackStatsService(data)
                document.getElementById(next).focus();
              }
              catch(error){
                console.log(error);
              };
            }
            
          }
        } catch (e) {
          console.log(e);
        }
      }
    },
    false
  );

  return (
    <Flex width="100%" justifyContent="center">
      <iframe src={url} width="99%" height="400"></iframe>
    </Flex>
  );
};

export default Document;
